import styled from 'styled-components';

interface Props {
  value: string;
  name: string;
}

/**
 *
 * @param value 복사할 값
 * @param name 버튼 이름
 */
function CopyButton({ name, value }: Props) {
  const handleCopy = () => {
    navigator.clipboard
      .writeText(value)
      .then(() => {
        alert('복사되었습니다!');
      })
      .catch((err) => {
        console.error('복사에 실패했습니다:', err);
        alert('복사에 실패했습니다.');
      });
  };

  return (
    <Button onClick={handleCopy}>
      <img
        src="/assets/images/icon/copy-blue.svg"
        alt=""
        width={16}
        height={16}
      />
      <span>{name}</span>
    </Button>
  );
}

export default CopyButton;

const Button = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  color: #008aff;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%; /* 17.4px */
  letter-spacing: -0.24px;
`;
